import React from 'react';
import {
    QuestionAnswer as SupportIcon,
    LibraryBooks as LibraryIcon,
    HelpOutline as FAQIcon,
} from '@material-ui/icons';

import TableIcon from './components/icons/TableIcon';
import UIicon from './components/icons/UIicon';
import FormsIcon from './components/icons/FormsIcon';
import ChartsIcon from './components/icons/ChartsIcon';
import MapIcon from './components/icons/MapIcon';
import ExtraIcon from './components/icons/ExtraIcon';
import MenuIcon from './components/icons/MenuIcon';
import CoreIcon from './components/icons/CoreIcon';
import DescriptionIcon from '@material-ui/icons/Description';


import { TEMPLATE_ROUTES } from '../../../config';

// components
import Dot from '../../../components/common/Sidebar/components/Dot';

const structure = [
    
]

export default structure
